import { Chakra } from "@airhelp/react-ui-components";
import type { ReactNode } from "react";
import { LIGHT_SHADOW } from "../../styles";

const { Flex } = Chakra;

const Card = ({ children }: { children: ReactNode }) => (
  <Flex
    py={{ base: 14, lg: 10 }}
    px={{ base: 4, lg: 8 }}
    rounded={{ base: "none", lg: "xl" }}
    borderBottom={{ base: "1px", lg: "none" }}
    borderColor="greyscale.400"
    bg="white"
    boxShadow={{ base: "none", lg: LIGHT_SHADOW }}
    flexDir="column"
  >
    {children}
  </Flex>
);

export default Card;
